<section class="container">
  <div class="msg" *ngIf="transferencias.length > 0"
    > <p style="margin-top: 10px; margin-bottom: 10px; text-align: center;"> Transferencia realizada com êxito! </p>
   </div
  >
  <h2 class="titulo">Extrato</h2>
  <table class="tabela">
    <thead class="tabela__cabecalho">
      <th class="tabela__cabecalho__conteudo">Data</th>
      <th class="tabela__cabecalho__conteudo">Valor</th>
      <th class="tabela__cabecalho__conteudo">Destino</th>
    </thead>
    <tbody *ngIf="transferencias.length > 0; else listaVazia">
      <tr class="tabela__linha" *ngFor="let transferencia of transferencias">
        <td class="tabela__conteudo">
          {{ transferencia?.data | date: "shortDate" }}
        </td>
        <td class="tabela__conteudo">{{ transferencia?.valor | currency }}</td>
        <td class="tabela__conteudo">{{ transferencia?.destino }}</td>
      </tr>
    </tbody>
  </table>
  <ng-template #listaVazia>
    <p class="listavazia">Nenhuma operação.</p>
  </ng-template>
</section>
